import { render, staticRenderFns } from "./CurriculumSavingActionSheet.vue?vue&type=template&id=60cf70ba&lang=pug"
import script from "./CurriculumSavingActionSheet.vue?vue&type=script&lang=js"
export * from "./CurriculumSavingActionSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports